/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { Token, TokenInterface } from "../contracts/Token";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "totalSupply",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "dec",
        type: "uint8",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Token__factory extends ContractFactory {
  constructor(...args: TokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    name: PromiseOrValue<string>,
    symbol: PromiseOrValue<string>,
    totalSupply: PromiseOrValue<BigNumberish>,
    dec: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Token> {
    return super.deploy(
      name,
      symbol,
      totalSupply,
      dec,
      overrides || {}
    ) as Promise<Token>;
  }
  override getDeployTransaction(
    name: PromiseOrValue<string>,
    symbol: PromiseOrValue<string>,
    totalSupply: PromiseOrValue<BigNumberish>,
    dec: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      name,
      symbol,
      totalSupply,
      dec,
      overrides || {}
    );
  }
  override attach(address: string): Token {
    return super.attach(address) as Token;
  }
  override connect(signer: Signer): Token__factory {
    return super.connect(signer) as Token__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TokenInterface {
    return new utils.Interface(_abi) as TokenInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Token {
    return new Contract(address, _abi, signerOrProvider) as Token;
  }
}
